module.exports = __webpack_public_path__ + "static/media/data.183ea97d.png";